export const isNil = value => value === undefined || value === null;

export const isNull = value => value === null;

export const isPositiveNumber = value => value > 0;
